import CompanyScreen from "./CompanyScreen.context";
import DriverScreen from "./DriverScreen.context";
import UserScreen from "./User.context";
import MunicipalityScreen from "./municipulity.context";
import TransactionsScreen from "./Transactions.context";
import OrderScreen from "./OrderScreen.context";
import ClientScreen from "./ClientScreen.context";
import CategoryScreen from "./CategoryScreen.context";
import CategoryPriceScreen from "./CategoryPriceScreen.context";
import WorkTimeScreen from "./WorkTimeScreen.context";
import AreaScreen from "./AreaScreen.context";
import AppContext from "./App.context";
import TicketContext from "./TicketScreen.context";

const Context = {
  CompanyScreen,
  MunicipalityScreen,
  DriverScreen,
  UserScreen,
  TransactionsScreen,
  OrderScreen,
  ClientScreen,
  CategoryScreen,
  CategoryPriceScreen,
  WorkTimeScreen,
  AreaScreen,
  AppContext,
  TicketContext,
};

export default Context;
